import { render, staticRenderFns } from "./ServiceSupportView.vue?vue&type=template&id=beded74a&"
import script from "./ServiceSupportView.vue?vue&type=script&lang=js&"
export * from "./ServiceSupportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports